<template>
    <div class="body-panel">
        <template v-if="sku != null && skuSettings != null">
            <div class="body-panel-control separator">
                <div class="control-block-left">
                    <div class="flex">
                        <p class="btn-back">
                            <a class="router-link-active" href="" @click.prevent="back">Назад</a>
                        </p>
                    </div>
                </div>
                <div class="control-block-right">
                    <div class="btns flex">
                        <button type="button" class="btn" @click="onEditSku()" v-if="info.User && (hasClaims(info.User.DynamicRole, claimEnums.skuCreate) || info.User.MainRole === 'administrators')">Редактировать</button>
                    </div>
                </div>
            </div>
            <div class="body-panel-content body-panel-content-page">
                <div class="body-panel page-content-block">
                    <div class="body-panel-control">
                        <p class="p-header-1" v-if="skuSettingsNameField.ShowInDetails">
                            {{ sku.Name }}
                        </p>
                    </div>
                    <div class="body-panel-content">
                        <div class="news-content margin-top-10" v-if="sku.Group != null">
                            <div class="news-content-left">
                                <p class="caption-help">Группа</p>
                            </div>
                            <div class="news-content-right">
                                <p class="caption-help">{{ sku.Group.Name }}</p>
                            </div>
                        </div>

                        <div :class="['news-content margin-top-10', s.FieldName]" v-for="s of skuSettingsOrdered">
                            <div class="news-content-left">
                                <p :class="['caption-help']">
                                    {{ s.Title }}<template v-if="s.FieldName === 'Volume'">, {{ sku.VolumeUnit }}</template><template v-if="s.FieldName === 'Weight'">, {{ sku.WeightUnit }}</template>
                                </p>
                            </div>
                            <div class="news-content-right">
                                <p class="caption-help" v-if="s.FieldName !== 'Description'">
                                    {{ sku[s.FieldName] }}<template v-if="s.FieldName === 'RRC'"> руб.</template>
                                </p>
                                <p class="caption-help" v-else v-html="DescriptionFormatted"></p>
                            </div>
                        </div>


                        <div class="news-content" v-if="sku.Image">
                            <div class="news-content-left">
                                <p class="caption-help">Изображение</p>
                            </div>
                            <div class="news-content-right">
                                <div class="news-content-right-img">
                                    <img :src="sku.Image" alt="" />
                                </div>
                            </div>
                        </div>
                        <div class="news-content" v-if="sku.StartDate">
                            <div class="news-content-left">
                                <p class="caption-help">Добавлено</p>
                            </div>
                            <div class="news-content-right">
                                <p class="caption-help">{{ sku.StartDate | date-short }}</p>
                            </div>
                        </div>
                        <div class="news-content margin-top-10" v-if="sku.EndDate">
                            <div class="news-content-left">
                                <p class="caption-help">Отключено</p>
                            </div>
                            <div class="news-content-right">
                                <p class="caption-help">{{ sku.EndDate | date-short }}</p>
                            </div>
                        </div>
                        <div class="news-content margin-top-10" v-if="info.User && info.User.MainRole === 'administrators' && sku.Links && sku.Links.length">
                            <div class="news-content-left">
                                <p class="caption-help">Связи с ТТ</p>
                            </div>
                            <div class="news-content-right">
                                <p class="caption-help" v-for="link of sku.Links">{{link.Name}} - {{link.Amount}}{{link.BonusType}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <vue-headful title="SKU" />
    </div>
</template>

<script>
    import BackendApi from '../../backendApi'
    import UI from '../../helpers/ui-helpers'
    import projectMixin from '../../helpers/project-mixin'
    import _ from 'lodash'

    let backendApi = new BackendApi();
    let skuCacheKey = 'skuState';

    export default {
        name: "sku-details",

        props: ['info'],

        mixins: [projectMixin], // projectId

        data() {
            return {
                sku: null,
                skuSettings: null
            }
        },

        computed: {
            DescriptionFormatted: function (){
                if(this.sku != null && this.sku.Description) {
                    return this.sku.Description.replace(/\n/g, '<br>');
                }
                else {
                    return null;
                }
            },

            skuSettingsOrdered(){
                if(this.skuSettings == null){
                    return null;
                }

                return _.orderBy(this.skuSettings.filter(x => x.ShowInDetails && x.FieldName !== 'Name' && this.sku[x.FieldName] !== null), 'SettingsOrder');
            },

            skuSettingsNameField(){
                return this.skuSettings.find(x => x.FieldName === 'Name');
            }
        },

        methods: {
            cancel() {
                this.$router.back();
            },

            onEditSku(){
                this.$router.push('/sku/edit/' + this.sku.Id);
            },

            loadSku() {
                let that = this;
                let id = parseInt(this.$route.params.id);
                return this.callApiWrapper(backendApi.skuLoad(id, this.projectId)).then(function (response) {
                    if (response.hasError) {
                        UI.toastr.error('Ошибка при загрузке sku');
                    }
                    else {
                        if(response.data == null)
                        {
                            that.$router.push('/sku');
                        }
                        else {
                            that.sku = response.data;
                        }
                    }
                })
            },

            loadSettings(){
                let vm = this;
                return this.callApiWrapper(backendApi.skuSettings(vm.projectId))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрузки настроек sku');
                        }
                        else {
                            if (resp.data) {
                                // let dict = {};
                                // for(let s of resp.data){
                                //     if(!dict[s.FieldName]){
                                //         dict[s.FieldName] = s;
                                //     }
                                // }
                                vm.skuSettings = resp.data;
                            }
                        }
                    })
            },

            back() {
                if (this.$route.query.saved !== undefined) {
                    // возвращаем строго на страницу sku, но с учётом folder
                    let stateObj = JSON.parse(sessionStorage.getItem(skuCacheKey));
                    if (stateObj && stateObj.folderId != null) {
                        this.$router.push('/sku/?folderId=' + stateObj.folderId);
                    } else {
                        this.$router.push('/sku');
                    }
                } else {
                    this.$router.back();
                }
            }
        },

        mounted() {
            UI.blockUI('.page-content', 'Загрузка...');
            Promise.all([this.loadSku(), this.loadSettings()]).then(() => {
                UI.unblockUI('.page-content');
            });
            // this.loadSku().then(() => {
            //     UI.unblockUI('.page-content');
            // });
        }

    }
</script>

<style scoped>
    .news-content-right .caption-help {white-space:unset}
</style>


// WEBPACK FOOTER //
// Content/src/views/details/SkuDetails.vue